<template>
  <div>
    <div class="content-header">
      <div class="left">租赁管理</div>
      <div class="right">
        <Button
          icon="md-add"
          type="primary"
          @click="EDIT(false)"
          v-if="$CheckShow($route.name,'ADD')"
        >新增租赁</Button>
      </div>
      <div class="bottom">
        <Input v-model="page.keyworld" style="width:280px;" placeholder="搜索商品名称或编号" />
        <Select v-model="page.status" style="width:200px;margin-left:10px;" placeholder="状态筛选">
          <Option value="0">上架</Option>
          <Option value="1">下架</Option>
        </Select>
        <Button type="primary" style="margin-left:10px;" icon="ios-search" @click="getData(true)">搜索</Button>
        <Button style="margin-left:10px;" @click="Reset()">重置</Button>
      </div>
    </div>

    <Table :columns="columns" :data="data">
      <template slot="main_img" slot-scope="{ row }">
        <div style="line-height: 0;padding: 2px 0">
          <img :src="row.main_img" width="50" height="50" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="action" fixed="right">
        <Button
          type="primary"
          size="small"
          @click="EDIT(row)"
          v-if="$CheckShow($route.name,'EDIT')"
        >编辑</Button>
        <Button
          :type="row.status === -1 || row.status === 1 ? 'success' : 'warning'"
          size="small"
          @click="upData(row.status === 1 ? 0 : 1,row.id)"
          v-if="$CheckShow($route.name,'EDIT')"
          style="margin-left:5px"
        >{{row.status === 1 ? '上架' : '下架'}}</Button>
      </template>
    </Table>
    <div class="t-right t-top-10">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="page.total"
        show-elevator
        show-sizer
        show-total
      />
    </div>

    <Drawer
      :title="modal.title"
      :closable="false"
      v-model="modal.status"
      width="800"
      :height="'calc(100% - 53px)'"
      :style="{height: 'calc(100% - 53px)', overflow: 'auto', paddingBottom: '53px', position: 'static'}"
    >
      <!-- :mask-style="{background:'rgba(0,0,0,0)'}" -->
      <Form
        ref="form"
        :model="modal.data"
        :rules="modal.rule"
        inline
        :label-width="90"
        style="padding-bottom:55px"
      >
        <div class="parts-title">基础信息</div>
        <FormItem prop="goods_sku_id" label="选择商品:">
          <Input
            search
            enter-button
            placeholder="请选择租赁商品"
            v-model="modal.GoodsName"
            style="width: 260px;"
            @on-search="initGoodsSelect"
            readonly
          />
        </FormItem>
        <FormItem prop="lease_show_money" label="默认价格:">
          <InputNumber
            v-model="modal.data.lease_show_money"
            :min="0"
            :active-change="false"
            :precision="2"
            style="width: 260px;"
          ></InputNumber>
        </FormItem>
        <FormItem prop="deposit" label="押金:">
          <InputNumber
            v-model="modal.data.deposit"
            :min="0"
            :active-change="false"
            :precision="2"
            style="width: 260px;"
          ></InputNumber>
        </FormItem>
        <FormItem prop="lease_unit" label="单位:">
          <Input
            v-model="modal.data.lease_unit"
            placeholder=""
            style="width: 260px;"
          ></Input>
        </FormItem>
        <FormItem label="立即上架:">
          <i-switch v-model="modal.switch" @on-change="switchChange" />
        </FormItem>
        <div class="parts-title">规格信息</div>
        <Button icon="md-add" style="width:280px;margin:10px 0;" @click="insertSkuList">添加规格选项</Button>
        <div class="itemBox">
          <div class="item" v-for="(item,key) in modal.skuInfo" :key="key">
            <div class="close" @click="itemClose(key)">
              <Icon type="md-close" />
            </div>
            <FormItem :label="'规格' + (key + 1)">
              <Input placeholder="请填写规格名称" v-model="item.name" style="width: 260px;" />
            </FormItem>
            <FormItem label="规格值">
              <Input
                placeholder="输入后回车确认"
                @on-enter="handleCreate(key)"
                v-model="item.val"
                style="width: 260px;"
              />
              <div class="tag" style="width: 260px;">
                <Tag
                  color="default"
                  v-for="(v,j) in item.child"
                  closable
                  :key="j"
                  @on-close="()=>{handleClose(key,j)}"
                >{{v}}</Tag>
              </div>
            </FormItem>
          </div>
        </div>
        <Table :columns="modal.columns" :data="modal.skuValue" v-show="modal.skuValue.length > 0">
          <template slot="money" slot-scope="{ row,index  }">
            <InputNumber
              class="money-input"
              :min="0"
              :active-change="false"
              :precision="2"
              v-model="row.money"
              @on-change="moneyInput($event,index)"
              style="width: 161px;"
              placeholder="请输入租赁价格"
            ></InputNumber>
          </template>
          <template slot="action" slot-scope="{ row,index }">
            <Button type="error" size="small" @click="deleteSkuValue(index)">删除</Button>
          </template>
        </Table>
      </Form>
      <div class="drawer-footer">
        <Button style="margin-right:10px;" type="primary" @click="save" :loading="modal.loading">确定</Button>
        <Button @click="modal.status = false" >取消</Button>
      </div>
    </Drawer>
    <goods-select v-model="modal.GoodsSelect" :multiple="false" @getGoods="goodsChange"></goods-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      modal: {
        status: false,
        GoodsSelect: false,
        GoodsName: "",
        title: "新增",
        switch: true,
        skuInfo: [], //规格项-规格值
        skuValue: [], //通过规格项-规格值计算后的list，规格商品
        columns: [
          {
            title: "规格",
            key: "value",
            width: 300
          },
          {
            title: "价格",
            slot: "money"
          },
          {
            title: "操作",
            slot: "action",
            width: 100
          }
        ],
        data: {
          //新增数据
          goods_sku_id: 0,
          lease_show_money: null,
          // total: null,
          status: 1,
          id: 0,
          deposit: 0,
          lease_unit:''
        },
        rule: {
          //表单规则
          goods_sku_id: [
            {
              required: true,
              type: "number",
              message: "请选择一项商品",
              trigger: "select"
            },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择一项商品"));
                } else callback();
              }
            }
          ],
          lease_show_money: [
            {
              required: true,
              type: "number",
              message: "请输入价格",
              trigger: "select"
            },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请输入价格"));
                } else callback();
              }
            }
          ],
          deposit: [
            {
              required: true,
              type: "number",
              message: "请输入押金",
              trigger: "select"
            },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请输入押金"));
                } else callback();
              }
            }
          ],
          total: [
            {
              required: true,
              type: "number",
              message: "请输入总数量",
              trigger: "select"
            },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请输入总数量"));
                } else callback();
              }
            }
          ],
          lease_unit: [
            {
              required: true,
              type: "string",
              message: "请输入单位",
              trigger: "select"
            },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请输入单位"));
                } else callback();
              }
            }
          ]
        }
      },
      data: [],
      page: {
        p: 0,
        l: 10,
        keyworld: "",
        status: "",
        total: 0
      },
      columns: [
        {
          title: "商品编号",
          key: "no"
        },
        {
          title: "商品名称",
          key: "name"
        },
        {
          title: "主图",
          slot: "main_img"
        },
        {
          title: "价格",
          key: "lease_show_money"
        },
        {
          title: "创建时间",
          key: "create_time"
        },
        {
          title: "剩余",
          key: "total"
        },
        {
          title: "总销量",
          key: "sales"
        },
        {
          title: "状态",
          key: "status_string"
        },
        {
          title: "操作",
          slot: "action",
          width: 130
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    let params = this.$GetParams(this.$route.name);
    for (let k in params) {
      if (params[k]) this.page[k] = params[k];
    }
  },
  methods: {
    ...mapActions(["SaveLeaseGoods", "GetLeaseGoods"]),
    initGoodsSelect() {
      this.modal.GoodsSelect = true;
    },
    upData(status = 0, id) {
      let data = {};
      (data.id = id), (data.status = status);
      this.SaveLeaseGoods(data).then(res => {
        if (res.status) {
          this.getData();
          this.$Message.success(res.msg);
        } else this.$Message.error(res.msg);
      });
    },
    save() {
      //保存
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = this.modal.data;
          data.sku_attr = this.modal.skuInfo;
          data.sku_value = this.modal.skuValue;
          let num = 0;
          for (let index = 0; index < data.sku_value.length; index++) {
            const element = data.sku_value[index];
            if (!element.money) {
              num++;
              this.$Message.error(`规格${element.value}请填写价格`);
              break;
            }
          }
          if (num) return false;
          if (data.status) data.status = 0;
          else data.status = 1;
          data.sku_attr = JSON.stringify(data.sku_attr);
          data.sku_value = JSON.stringify(data.sku_value);
          this.SaveLeaseGoods(data).then(res => {
            if (res.status) {
              this.getData();
              this.$Message.success(res.msg);
              this.modal.status = false;
              this.modal.data = {
                goods_sku_id: 0,
                sku: [],
                lease_show_money: null,
                deposit: null,
                total: null,
                status: 1,
                id: 0
              };
              this.modal.skuValue = [];
              this.modal.skuInfo = [];
              this.modal.GoodsName = "";
            } else this.$Message.error(res.msg);
          });
        }
      });
    },
    EDIT(row) {
      //编辑，初始化表单
      if (!row) {
        this.modal.status = true;
        this.modal.GoodsName = "";
        this.modal.skuInfo = [];
        this.modal.skuValue = [];
        this.modal.title = "新增";
        this.modal.data = {
          goods_sku_id: 0,
          lease_show_money: null,
          total: null,
          status: 1,
          id: 0,
          deposit: null,
          lease_unit:""
        };
      } else {
        this.modal.status = true;
        this.modal.skuInfo = row.sku_attr;
        this.modal.skuValue = row.sku_value;
        this.modal.GoodsName = row.name;
        this.modal.title = "编辑";
        this.modal.data = {
          goods_sku_id: row.goods_sku_id,
          lease_show_money: row.lease_show_money,
          total: row.total,
          status: row.status,
          id: row.id,
          deposit: row.deposit,
          lease_unit:row.lease_unit
        };
      }
    },
    switchChange(e) {
      //是否立即上架
      if (e) this.modal.data.status = 1;
      else this.modal.data.status = 0;
    },
    handleCreate(k) {
      //创建规格值
      let child = this.modal.skuInfo[k].child,
        val = this.modal.skuInfo[k].val;
      if (!val) return;
      if (child.length >= 5) {
        this.$Message.error("最多添加5项规格值");
        return false;
      }
      if (child.indexOf(val) >= 0) this.$Message.error("当前规格值已存在");
      else child.push(val);
      this.modal.skuInfo[k].val = "";
    },
    handleClose(key, index) {
      //删除单项规格值
      this.modal.skuInfo[key].child.splice(index, 1);
    },
    itemClose(k) {
      //删除规格项
      this.modal.skuInfo.splice(k, 1);
    },
    insertSkuList() {
      //新增规格项
      if (this.modal.skuInfo.length >= 3) {
        this.$Message.error("最多添加三组属性");
        return false;
      }
      this.modal.skuInfo.push({
        name: "",
        child: []
      });
    },
    deleteSkuValue(index) {
      //删除计算后的规格数据
      this.modal.skuValue.splice(index, 1);
    },
    moneyInput(e, index) {
      this.modal.skuValue[index].money = e;
    },
    goodsChange(row) {
      //选择商品后的回调
      console.log(row);
      this.modal.GoodsName = row.name;
      this.modal.data.goods_sku_id = row.goods_sku_id;
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    Reset() {
      this.page = {
        l: 10,
        p: 0,
        status: "",
        keyworld: "",
        total: 0
      };
      this.$PushParams(this.$route.name, false);
      this.getData();
    },
    getData(IsSearch) {
      if (IsSearch) this.page.p = 0;
      this.$PushParams(this.$route.name, this.page);
      this.GetLeaseGoods(this.page).then(res => {
        res.data.map(item => {
          item.sku_attr = item.sku_attr ? JSON.parse(item.sku_attr) : {};
          item.sku_value = item.sku_value ? JSON.parse(item.sku_value) : {};
          item.status_string = item.status === 0 ? "上架" : "下架";
          item.create_time = this.$moment(item.create_time, "YYYY-MM-DD hh:mm");
        });
        this.data = res.data;
        this.page.total = res.total;
      });
    }
  },
  computed: mapGetters({}),
  watch: {
    "modal.skuInfo": {
      handler(val, oldVal) {
        let lease_show_money = this.modal.data.lease_show_money;
        let data = [];
        this.modal.skuInfo.map(item => {
          if (item.child.length) data.push(item.child);
        });
        if (!data.length) {
          this.modal.skuValue = [];
          return false;
        }
        let sarr = [[]];
        for (let i = 0; i < data.length; i++) {
          let tarr = [];
          for (let j = 0; j < sarr.length; j++) {
            for (let k = 0; k < data[i].length; k++) {
              tarr.push(sarr[j].concat(data[i][k]));
            }
          }
          sarr = tarr;
        }
        let temp = [];
        sarr.map((item, index) => {
          temp[index] = {
            value: item.join("_"),
            money: this.modal.skuValue[index]
              ? this.modal.skuValue[index].money
              : lease_show_money
          };
        });
        this.modal.skuValue = temp;
      },
      deep: true
    }
  }
};
</script>
<style lang='less' scoped>

.itemBox {
  .item {
    border: 1px solid #eee;
    padding: 20px 0 0 0;
    border-radius: 5px;
    margin: 20px 0;
    position: relative;
    overflow: hidden;
    width: 100% !important;
    height: auto !important;
    .close {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 20px;
      height: 20px;
      text-align: right;
      cursor: pointer;
    }
  }
}
</style>
